import React, { useState } from 'react';
import { statusList } from '.';

type UseViewModelProps = {
  value: string;
  onChange: (value: string) => void;
};

type UseViewModelReturn = {
  status: string;
  anchorEl: HTMLButtonElement;
  handleChange: (item: string) => void;
  handleClick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  handleClose: () => void;
};

const useViewModel = ({
  value,
  onChange,
}: UseViewModelProps): UseViewModelReturn => {
  const [status, setStatus] = useState(value === '' ? statusList[0] : value);
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement>(null);

  const handleChange = (item: string): void => {
    const newValue = item === statusList[0] ? '' : item;
    setStatus(item);
    onChange(newValue);
    setAnchorEl(null);
  };

  const handleClick = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ): void => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (): void => {
    setAnchorEl(null);
  };

  return { status, anchorEl, handleChange, handleClick, handleClose };
};

export default useViewModel;
